import React, { useState,useEffect } from 'react';
import WarehouseTransactionDatatable from './WarehouseTransactionDatatable';




const WarehouseTransactionTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
  

    const handleCallback = (id) => {
          setRecordId(id);       
        
    };
 
 
    useEffect(() => {      
      setRecordId(props.selectedRecord);
    }, [props.selectedRecord])
  
  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <WarehouseTransactionDatatable            
            parentCallback={handleCallback}    
            warehouseId={recordId}                                
          />
         
        </div>
    );
};

export default WarehouseTransactionTab;